export const analyticsDashboardAppGroupIdCreditConsumptionData =
  "/analytics_dashboard/:app_group_id/credit_consumption_data";
